import React from 'react';
import NodeProjectFull from './Full';

import { SimpleTeaser } from '../../../components';

const NodeProject = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <SimpleTeaser withSummary {...props} />;

    default:
      return <NodeProjectFull {...props} />;
  }
};

export default NodeProject;
